import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface KdsTimerProps {
  openedAt: string;
  slaWarningSeconds?: number;
  slaCriticalSeconds?: number;
  className?: string;
}

export function KdsTimer({ openedAt, slaWarningSeconds = 600, slaCriticalSeconds = 1200, className }: KdsTimerProps) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const start = new Date(openedAt).getTime();
    const update = () => setElapsed(Math.floor((Date.now() - start) / 1000));
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [openedAt]);

  const minutes = Math.floor(elapsed / 60);
  const seconds = elapsed % 60;
  const display = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  const level = elapsed >= slaCriticalSeconds ? "critical" : elapsed >= slaWarningSeconds ? "warning" : "normal";

  return (
    <span
      className={cn(
        "font-mono text-sm font-bold tabular-nums",
        level === "normal" && "text-emerald-400",
        level === "warning" && "text-amber-400 animate-pulse",
        level === "critical" && "text-red-400 animate-pulse",
        className
      )}
    >
      {display}
    </span>
  );
}
